export default __webpack_public_path__ + "images/logo-bw-solo.svg?6d2d2a942ff73e2203f9063935a87aa7";